import React, { useEffect } from "react"
import { Outlet, useLocation } from "react-router-dom"
import LandingPrayerTestimonyModals from "./landing/LandingPrayerTestimonyModals"
import { isPrayerTestimonyHash } from "../lib/prayerTestimony"

const LandingLayout: React.FC = () => {
  const location = useLocation()

  useEffect(() => {
    if (!location.hash || isPrayerTestimonyHash(location.hash)) return

    const id = decodeURIComponent(location.hash.slice(1))
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches

    const scrollToTarget = () => {
      const target = document.getElementById(id)
      if (target) {
        target.scrollIntoView({
          behavior: prefersReducedMotion ? "auto" : "smooth",
          block: "start",
        })
      }
    }

    // Wait for the destination page/section to mount after route changes.
    const timeout = window.setTimeout(scrollToTarget, 50)
    return () => window.clearTimeout(timeout)
  }, [location.pathname, location.hash])

  return (
    <div className="min-h-screen bg-base-100">
      <Outlet />
      <LandingPrayerTestimonyModals />
    </div>
  )
}

export default LandingLayout
